import { IStorageBackend } from "./storage-backend"

export class LocalStorageBackend implements IStorageBackend {
  constructor(private window: Window) {}

  getItem(key: string): string | null {
    try {
      return this.window.localStorage.getItem(key)
    } catch {
      // Handle cases where localStorage might not be available (e.g., in tests)
      return null
    }
  }

  setItem(key: string, value: string): void {
    try {
      this.window.localStorage.setItem(key, value)
    } catch {
      // Handle cases where localStorage might not be available (e.g., in tests)
      // Silently fail to avoid breaking the app
    }
  }
}
